import React, {
  memo, useLayoutEffect, useRef, useState,
} from 'react'

import { number, shape, string } from 'prop-types'
import { createPortal } from 'react-dom'

const VIEWPORT_MARGIN = 8

// Drawn like Triangle's top tooltip, but shown from code, which its hover-driven Tooltip
// cannot do. Portalled to the body with fixed coordinates because the Share button sits
// flush with the top of the editor's scroll box, which would clip a bubble above it.
// Visual only (aria-hidden): the button's status region already announces the copy.
function CopiedTooltip({ anchor, label }) {
  const bubbleRef = useRef(null)
  const [shift, setShift] = useState(0)

  // Centred on the button, but on a phone the button sits near the viewport's right edge and
  // longer translations (ja, ru) would run off-screen. Nudge the bubble back inside and move
  // the arrow the other way so it keeps pointing at the button. Measured before paint.

  useLayoutEffect(() => {
    const halfWidth = bubbleRef.current.offsetWidth / 2
    const viewportWidth = document.documentElement.clientWidth
    const overflowRight = anchor.centerX + halfWidth - (viewportWidth - VIEWPORT_MARGIN)
    const overflowLeft = VIEWPORT_MARGIN - (anchor.centerX - halfWidth)

    if (overflowRight > 0) {
      setShift(-overflowRight)
    } else {
      setShift(Math.max(overflowLeft, 0))
    }
  }, [anchor, label])

  return createPortal(
    <span
      ref={bubbleRef}
      className="image-assistant-edit-tab__share-tooltip cgt-caption"
      style={{
        top: anchor.top,
        left: anchor.centerX + shift,
        '--copied-tooltip-arrow-shift': `${-shift}px`,
      }}
      aria-hidden="true"
    >
      {label}
    </span>,
    document.body,
  )
}

CopiedTooltip.propTypes = {
  anchor: shape({ top: number, centerX: number }).isRequired,
  label: string.isRequired,
}

export default memo(CopiedTooltip)
